import { useMemo } from "react";
import { useMandatorContext } from "@bn/theming";
import { resolvePortalUrl, USE_INTERNAL_AUTH } from "@helpers";

const BASE = import.meta.env.VITE_APP_APP_URL;
const DEFAULT_LOGIN_PATH = "/login";
const DEFAULT_SIGNUP_PATH = "/signup";

const normalize = (p: string) => p.replace(/\/+$/, "") || "/";

export function useLoginRoute() {
  const { config } = useMandatorContext();

  return useMemo(() => {
    const isLoginPath = (pathname: string) => {
      const normalizedPath = normalize(pathname);
      return normalizedPath === DEFAULT_LOGIN_PATH;
    };

    const loginRedirectUrl = USE_INTERNAL_AUTH
      ? `${BASE}${DEFAULT_LOGIN_PATH}`
      : (resolvePortalUrl(config.links?.login) ??
        `${BASE}${DEFAULT_LOGIN_PATH}`);

    const registrationRedirectUrl = USE_INTERNAL_AUTH
      ? `${BASE}${DEFAULT_SIGNUP_PATH}`
      : (resolvePortalUrl(config.links?.registration) ?? loginRedirectUrl);

    return {
      loginRedirectUrl,
      registrationRedirectUrl,
      isLoginPath,
    };
  }, [config.links]);
}
